import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Align, PopupAnimation } from "@progress/kendo-angular-popup";

@Component( {
    selector: 'cp-copy-field-text',
    templateUrl: './copy-field-text.component.html',
    styleUrls: ['./copy-field-text.component.scss'],
    standalone: false
} )
export class CopyFieldTextComponent implements OnInit {

    copiedText: string;
    @Input() set textToCopy (args: string){
        this.copiedText = args;
        this.showCopy = this.copiedText != null && this.copiedText.length > 0;
    };
    showCopy: boolean = false;
    popUp: boolean = false;
    public anchorAlign: Align = { horizontal: "right", vertical: "bottom" };
    public popupAlign: Align = { horizontal: "right", vertical: "top" };
    public get animate(): boolean | PopupAnimation {
        if (this.popUp) {
            return {
                type: 'slide',
                direction: 'down',
                duration: 60,
            };
        }

        return false;
    }

    constructor() {}

    ngOnInit() {
    }

    ngAfterViewInit() {
       /* if (this.textToCopy != null) {
            this.showCopy = true;
            console.log('ngAfterViewInit ' + this.showCopy);
        }*/
    }

    showCopyButton() {
        //return this.textToCopy != null
    }

    copyField( value ) {
        if ( navigator['clipboard'] ) {
            window.navigator['clipboard'].writeText( value ).then( () => {
                this.popUp = true;
                setTimeout(() => {
                    this.popUp = false;
                }, 850);
                console.log( 'copied ' + value )
            }, ( error ) => {
                console.log( error )
            } );
        } else {
            console.log( 'Browser do not support Clipboard API' )
        }
    }

}
